import { render, staticRenderFns } from "./dataAI.vue?vue&type=template&id=0052a1aa&scoped=true"
import script from "./dataAI.vue?vue&type=script&lang=js"
export * from "./dataAI.vue?vue&type=script&lang=js"
import style0 from "./dataAI.vue?vue&type=style&index=0&id=0052a1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0052a1aa",
  null
  
)

export default component.exports